"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskLevel = void 0;
var PRC_1 = require("../PRC");
var RiskLevel;
(function (RiskLevel) {
    RiskLevel["low"] = "L";
    RiskLevel["moderate"] = "M";
    RiskLevel["high"] = "H";
})(RiskLevel = exports.RiskLevel || (exports.RiskLevel = {}));
var Risk = /** @class */ (function () {
    function Risk() {
        this.type = PRC_1.PRCType.risk;
        this.id = '';
        this.name = '';
        this.cycleName = '';
        this.categoryName = '';
        this.subCategoryName = '';
        this.cycleNumber = '';
        this.categoryNumber = '';
        this.subCategoryNumber = '';
        this.inherentRiskLevel = RiskLevel.low;
        // TODO(sangmuk): Array를 단일 값으로 변경.
        this.cycleIds = [];
        this.processIds = [];
        this.controlIds = [];
    }
    return Risk;
}());
exports.default = Risk;
//# sourceMappingURL=AbstractRisk.js.map